<template>
  <v-overlay :value="showLoading" color="white" opacity="1">
    <v-progress-circular indeterminate size="64" color="primary">
    </v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Loading',
  computed: mapGetters(['showLoading']),
};
</script>
